import { AppShell } from "../components/AppShell";
import { PageHeader } from "../components/PageHeader";
import { Toolbar } from "../components/Toolbar";
import { LITURGY_SCHEMA_VERSION } from "../lib/types";
import schemaMarkdown from "../../catalog/SCHEMA.md?raw";

const CKDB_HREF = "/catalog/gospelgo-schema-v1.ckdb";

export function SchemaPage() {
  return (
    <AppShell>
      <PageHeader
        eyebrow="Reference"
        title="Schema"
        description={
          <>
            CloudKit Public record types for liturgy content. Version{" "}
            <strong>v{LITURGY_SCHEMA_VERSION}</strong> — download the <code>.ckdb</code> and import
            it in CloudKit Dashboard (Development), then seed sample data from Overview.
          </>
        }
        actions={
          <Toolbar>
            <a className="btn btn-primary btn-sm" href={CKDB_HREF} download="gospelgo-schema-v1.ckdb">
              Download .ckdb
            </a>
            <a className="btn btn-quiet btn-sm" href="/catalog/SCHEMA.md" download>
              Download Markdown
            </a>
          </Toolbar>
        }
      />

      <div className="panel panel-pad stack" style={{ marginBottom: 16 }}>
        <div className="section-title">
          <h2>Import into CloudKit</h2>
          <p>
            Server-to-server writes cannot create record types. Import this schema into{" "}
            <strong>Development</strong> first.
          </p>
        </div>
        <ol className="muted" style={{ margin: 0, paddingLeft: 20, fontSize: 14, lineHeight: 1.55 }}>
          <li>
            Download <code>gospelgo-schema-v1.ckdb</code>
          </li>
          <li>
            Open{" "}
            <a
              className="link-inline"
              href="https://icloud.developer.apple.com/dashboard"
              target="_blank"
              rel="noreferrer"
            >
              CloudKit Dashboard
            </a>{" "}
            → <code>iCloud.dev.disguised.gospelgo</code> → Schema → Import
          </li>
          <li>
            Or:{" "}
            <code>
              xcrun cktool import-schema --team-id TEAM --container-id iCloud.dev.disguised.gospelgo
              --environment development --file gospelgo-schema-v1.ckdb
            </code>
          </li>
          <li>
            Return to Overview → <strong>Seed Development schema</strong> for sample records
          </li>
        </ol>
      </div>

      <div className="panel panel-pad">
        <pre className="schema-doc">{schemaMarkdown}</pre>
      </div>
    </AppShell>
  );
}
